import { useCallback, useMemo } from 'react'

import { Room } from '@/core/models/room.model'

import { useAppDispatch, useAppSelector } from '@/redux/rootReducer'
import { selectAuthUser } from '@/redux/reducers/auth.reducer'
import { joinMeeting } from '@/redux/reducers/consultation.reducer'

import { isStaff } from '@/utils/type-guards'

type UseJoinEmergencyMeetingParams = {
  consultationRoom?: Room
  roomId?: string
}

export function useJoinEmergencyMeeting({ consultationRoom, roomId }: UseJoinEmergencyMeetingParams) {
  const dispatch = useAppDispatch()
  const authUser = useAppSelector(selectAuthUser)

  const isStreamer = useMemo(() => {
    if (!authUser || !consultationRoom) return false

    const creatorId = typeof consultationRoom.creator === 'string' ? consultationRoom.creator : consultationRoom.creator._id

    return authUser._id === creatorId
  }, [authUser, consultationRoom])

  const handleJoinMeeting = useCallback(() => {
    if (!authUser || !isStaff(authUser)) return

    if (authUser.status === 'MEDECIN' && roomId) {
      dispatch(joinMeeting({ roomOrConsultationId: roomId, userId: authUser._id, meetingType: 'visioConference' }))
      return
    }

    if (authUser.status === 'PDS' && authUser.emergencyRoom) {
      const emergencyRoomId = typeof authUser.emergencyRoom === 'string' ? authUser.emergencyRoom : authUser.emergencyRoom._id

      dispatch(joinMeeting({ roomOrConsultationId: emergencyRoomId, userId: authUser._id, meetingType: 'visioConference' }))
    }
  }, [dispatch, authUser, roomId])

  return { handleJoinMeeting, isStreamer }
}
